import { ConcursoProvaData } from "./concurso-prova-data"

export interface ExaminadorUnicampConsulta {
  nomeCompleto: string
  matricula: string
  email: string
  unidade: string
  employeeType: string
  titulacao?: Titulacao
  situacao?: SituacaoFuncional
  enabled: boolean
  serviceAccount: boolean
  classeFuncional?: ClasseFuncional
  dataTitulacao?: string
  concursosProvasData: Array<ConcursoProvaData>;
}

export enum Titulacao {
  GRADUACAO = 1,
  MESTRADO = 2,
  DOUTORADO = 3,
  POS_DOUTORADO = 4,
  LIVRE_DOCENCIA = 5,
  ADJUNTO = 6,
  TITULAR = 7
}

export enum SituacaoFuncional {
  NORMAL = 1,
  AFASTADO = 2,
  DEMITIDO = 3,
  NOVO = 4,
  COMPL_APOSENTADORIA = 5,
  INICIO_EXERCICIO = 7,
  DEMITIDO_CLT_APOSENTADO = 8
}

export enum ClasseFuncional {
  DOCENTE = 'D',
  EXTRA_QUADRO = 'E',
  MONITOR_BOLSISTA = 'O',
  OBRAS = 'P'
}